export const allResourcesResourceType = "all_resources";
export const liveUsageSidePanelId = "live-usage-side-panel-navigation";
